import { config } from '../constants/config_constants';
import superAgentRequest from 'superagent';


const LOGIN_URL = `${config.endpoints.BITMOJI_API}user/login`;
const LOGOUT_URL = `${config.endpoints.BITMOJI_API}user/logout`;
class BSAuthService {

    static login(username, password) {
        const payload = {
            client_id: 'imoji',
            username: username,
            password: password,
            grant_type: 'password',
            client_secret: 'secret'
        };

        return new Promise(function (resolve, reject) {
            superAgentRequest
                .post(LOGIN_URL)
                .type('application/x-www-form-urlencoded')
                .set('Accept', 'application/json')
                .send(payload)
                .end((err, res) => {
                    if (err || !res.ok) {
                        reject(err);
                    } else {
                        if (res.body.error){
                            reject(res.body.error);
                            return;
                        }

                        resolve(res.body.access_token);
                    }
                });
        });
    }


    static logoutUser(bsAuthToken) {
        return new Promise(function (resolve, reject) {
            superAgentRequest
                .post(LOGOUT_URL)
                .type('application/x-www-form-urlencoded')
                .set('bitmoji-token', bsAuthToken)
                .end((err, res) => {
                    if (err || !res.ok) {
                        reject(err);
                    } else {
                        resolve(res.body);
                    }
                });
        });
    }
}

export default BSAuthService;


// WEBPACK FOOTER //
// ./src/services/BSAuthService.js